import { render, staticRenderFns } from "./AssignedEvents.vue?vue&type=template&id=8d42930a"
import script from "./AssignedEvents.vue?vue&type=script&lang=js"
export * from "./AssignedEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports